import React, { useState } from "react";
import dayjs from "dayjs";

const fmt = (d) =>
  d && dayjs(d).isValid() ? dayjs(d).format("MM/DD/YYYY") : "";

export default function VitalsModal({
  temp,
  setTemp,
  tempUnit,
  setTempUnit,
  tempSite,
  setTempSite,
 finalsave,
    finalload,
  o2,
  setO2,
  o2Position,
  setO2Position,

  resp,
  setResp,
  respPosition,
  setRespPosition,

  handleSave,
  previousdata = {},
}) {
  const [isGlobalEdit, setIsGlobalEdit] = useState(true); // initially edit mode
  const clearAllFields = () => {
  setTemp("");
  setTempSite("");
  setTempUnit("");

  setO2("");
  setO2Position("");

  setResp("");
  setRespPosition("");
};

  const hydrateFromPrevious = () => {
    setTemp(previousdata?.temp || "");
    setTempSite(previousdata?.temp_drop || "");
    setTempUnit(previousdata?.temp_cel || "");

    setO2(previousdata?.o2_1 || "");

    setO2Position(previousdata?.o2_drop);
    setResp(previousdata?.respiratory);
    setRespPosition(previousdata?.respiratory_drop);
  };
console.log("Previous Data in Vitals Modal:", previousdata);
  return (
    <div className="bg-white p-6">
      <div className="flex items-center gap-2 justify-end mb-4">

  {/* + only in VIEW mode */}
  {!isGlobalEdit && (
    <div
      onClick={() => {
    clearAllFields()
        setIsGlobalEdit(true);
      }}
      className="h-8 w-8 cursor-pointer rounded-full bg-[#FDE2DA] text-[#E07A5F] text-xl flex items-center justify-center"
    >
      +
    </div>
  )}

  {/* Save only in EDIT mode */}
  {isGlobalEdit && (
    <button
      onClick={() => {
        finalsave();          // parent save
        setIsGlobalEdit(false); // switch to view
      }}
      className="rounded-md bg-[#1D2951] px-6 py-1 text-sm font-semibold text-white"
      disabled={finalload}
    >
      Save
    </button>
  )}
</div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {/* ================= TEMPERATURE ================= */}
        <EditableCard
          title="Temperature"
          hydrateFromPrevious={hydrateFromPrevious}
  clearAllFields={clearAllFields}
  isGlobalEdit={isGlobalEdit}
        >
          {({ isEditing, stopEdit }) =>
            !isEditing ? (
              <>
<BigValue>
  {previousdata?.temp !== "" &&
  previousdata?.temp !== null &&
  previousdata?.temp !== undefined
    ? previousdata.temp
    : "-"}

  {previousdata?.temp !== "" &&
    previousdata?.temp !== null &&
    previousdata?.temp !== undefined && (
      <Unit>{previousdata?.temp_cel}</Unit>
    )}
</BigValue>


                <Meta text={fmt(previousdata?.created_at)} />
                <Tag text={previousdata?.temp_drop || "—"} />
              </>
            ) : (
              <>
                <div className="flex flex-col justify-start items-start">
                  <Label>Reading</Label>
                
                <Input value={temp} onChange={setTemp} />

                {/* Temperature unit pill toggle */}
 
  <div className="mt-3 inline-flex items-center gap-1 rounded-xl bg-slate-100 p-1">
    {["°F", "°C", "K"].map((u) => (
      <UnitBtn
        key={u}
        active={tempUnit === u}
        onClick={() => setTempUnit(u)}
      >
        {u}
      </UnitBtn>
    ))}
  </div>



                <div className="w-full mt-3">
                  <Select
                    value={tempSite}
                    onChange={setTempSite}
                    options={["Ear", "Oral", "Axillary", "Forehead", "Dry"]}
                  />
                </div>

                {/* <Actions
                  onSave={() => {
                    handleSave();
                    stopEdit();
                  }}
            onCancel={() => {
  hydrateFromPrevious();   // restore previous values
  stopEdit();
}}

                /> */}
                </div>
              </>
            )
          }
        </EditableCard>

        {/* ================= O2 SATURATION ================= */}
        <EditableCard
          title="O2 Saturation"
          isGlobalEdit={isGlobalEdit}
          hydrateFromPrevious={hydrateFromPrevious}
            clearAllFields={clearAllFields}
        >
          {({ isEditing, stopEdit }) =>
            !isEditing ? (
              <>
               <BigValue>
  {previousdata?.o2_1 !== "" &&
  previousdata?.o2_1 !== null &&
  previousdata?.o2_1 !== undefined
    ? previousdata.o2_1
    : "-"}

  {previousdata?.o2_1 !== "" &&
    previousdata?.o2_1 !== null &&
    previousdata?.o2_1 !== undefined && (
      <Unit>%</Unit>
    )}
</BigValue>

                <Meta text={fmt(previousdata?.created_at)} />
                <Tag text={previousdata?.o2_drop || ""} />
              </>
            ) : (
              <>
                <div className="text-start">
                  <Label>Level</Label>
                </div>
                <Input value={o2} onChange={setO2} suffix="%" />

                <div className="mt-3">
                  <Select
                    value={o2Position}
                    onChange={setO2Position}
                    options={["Room Air", "On Oxygen"]}
                  />
                </div>

                {/* <Actions
                  onSave={() => {
                    handleSave();
                    stopEdit();
                  }}
              onCancel={() => {
  hydrateFromPrevious();   // restore previous values
  stopEdit();
}}

                /> */}
              </>
            )
          }
        </EditableCard>

        {/* ================= RESPIRATORY ================= */}
        <EditableCard
          title="Respiratory"
          hydrateFromPrevious={hydrateFromPrevious}
isGlobalEdit={isGlobalEdit}
            clearAllFields={clearAllFields}
        >
          {({ isEditing, stopEdit }) =>
            !isEditing ? (
              <>
               <BigValue>
  {previousdata?.respiratory !== "" &&
  previousdata?.respiratory !== null &&
  previousdata?.respiratory !== undefined
    ? previousdata.respiratory
    : "-"}

  {previousdata?.respiratory !== "" &&
    previousdata?.respiratory !== null &&
    previousdata?.respiratory !== undefined && (
      <Unit>breaths/min</Unit>
    )}
</BigValue>

                <Meta text={fmt(previousdata?.created_at)} />
                <Tag text={previousdata?.respiratory_drop || "-"} />
              </>
            ) : (
              <>
                <div className="text-start">
                  <Label>Rate</Label>
                </div>
                <Input value={resp} onChange={setResp} suffix="/ min" />

                <div className="mt-3">
                  <Select
                    value={respPosition}
                    onChange={setRespPosition}
                    options={["Normal", "Labored", "Irregular"]}
                  />
                </div>

                {/* <Actions
                  onSave={() => {
                    handleSave();
                    stopEdit();
                  }}
               onCancel={() => {
  hydrateFromPrevious();   // restore previous values
  stopEdit();
}}

                /> */}
              </>
            )
          }
        </EditableCard>
      </div>
    </div>
  );
}

/* ================= REUSABLE UI ================= */

const EditableCard = ({ title, children, hydrateFromPrevious , isGlobalEdit,clearAllFields}) => {
  const [isEditing, setIsEditing] = useState(false);
  React.useEffect(() => {
    setIsEditing(isGlobalEdit);
  }, [isGlobalEdit]);
  return (
    <div className="relative rounded-xl border bg-[#F9FAFB] p-6">
      <div className="flex justify-between">
        <div className="font-medium text-[#1D2951]">{title}</div>
        {/* {!isEditing && (
          <button
            onClick={() => {
            clearAllFields();  
              setIsEditing(true);
            }}
            className="h-8 w-8 rounded-full bg-[#FDE2DA] text-[#E07A5F] text-xl"
          >
            +
          </button>
        )} */}
      </div>

      <div className="mt-4">
        {children({ isEditing, stopEdit: () => setIsEditing(false) })}
      </div>
    </div>
  );
};

const BigValue = ({ children }) => (
  <div className="text-[36px] font-bold text-[#1D2951]">{children}</div>
);

const Unit = ({ children }) => (
  <span className="ml-1 text-lg text-slate-500">{children}</span>
);

const Meta = ({ text }) => (
  <div className="mt-1 text-sm text-slate-400">{text}</div>
);

const Tag = ({ text }) => (
  <div className="mt-3 inline-block rounded bg-slate-100 px-3 py-1 text-sm text-slate-600">
    {text}
  </div>
);

const Label = ({ children }) => (
  <div className="mb-1 text-sm text-slate-600">{children}</div>
);

const Input = ({ value, onChange, suffix }) => (
  <div className="relative">
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-10 w-full rounded border px-3 pr-12"
    />
    {suffix && (
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-slate-400">
        {suffix}
      </span>
    )}
  </div>
);

const Select = ({ value, onChange, options }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="h-10 w-full rounded border px-3"
  >
    {options.map((o) => (
      <option key={o} value={o}>
        {o}
      </option>
    ))}
  </select>
);

const UnitBtn = ({ active, children, onClick }) => (
  <button
    onClick={onClick}
    className={`rounded-xl px-3 py-2 text-sm font-medium transition ${
      active
        ? "bg-white text-[#E07A5F] shadow-sm"
        : "bg-transparent text-slate-500 hover:text-slate-700"
    }`}
  >
    {children}
  </button>
);

const Actions = ({ onSave, onCancel }) => (
  <div className="mt-6 flex gap-4">
    <button
      onClick={onSave}
      className="rounded bg-[#E07A5F] px-6 py-2 text-white"
    >
      Save
    </button>
    <button onClick={onCancel} className="text-[#1D2951]">
      Cancel
    </button>
  </div>
);
